import React from 'react'
import { connect } from 'react-redux'

class NegativeImportantInfo extends React.Component {

    // FIXME Styles/layout
    render() {
        return (
            <div>
                <div>{this.props.strings.POPUP_NEGATIVE_MESSAGE_1}</div><br/>
                <div>
                    <p>
                        {this.props.strings.POPUP_NEGATIVE_MESSAGE_2}
                        <b><a href={this.props.strings.COVID_MAIN_PAGE_LINK}>{this.props.strings.POPUP_NEGATIVE_MESSAGE_3}</a></b>
                        {this.props.strings.POPUP_NEGATIVE_MESSAGE_4}
                    </p>
                </div>
                <div>
                    <p>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1A}
                        <strong>
                            <a href={this.props.strings.TREATMENT_LINK}>{this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1B}</a>
                        </strong>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1C}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

const ConnectedNegativeImportantInfo = connect(
    mapStateToProps
)(NegativeImportantInfo);
export default ConnectedNegativeImportantInfo;
